<div>

  @if (auth.isloggedIn) {
    <nav class="fusion-navbar navbar navbar-expand-xl">
      <div class="container-fluid ps-nav">
        <!-- Brand -->
        <a class="navbar-brand fusion-brand" routerLink="/">
          <div class="brand-logo-wrap">
            <img src="assets/img/logo-header.png" style="height:38px; display:inline-block; vertical-align:middle;">
          </div>
          <span class="brand-title">{{'HEADER.INFO' | translate}}</span>
        </a>
        <!-- Mobile-only notification bell with dropdown (before toggler) -->
        <div class="d-xl-none ms-auto" ngbDropdown placement="bottom-end">
          <button class="btn btn-link mobile-notif-btn" ngbDropdownToggle aria-label="Notifications">
            <lucide-icon name="bell" style="color:rgba(255,255,255,0.85); display:block;" size="22"></lucide-icon>
            @if (unseenNotifications > 0) {
              <span class="notification_num">{{unseenNotifications}}</span>
            }
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end">
            @for (value of dropDownNotifications?.slice(0,10); track value) {
              <div style="width:100%;">
                <button ngbDropdownItem style="font-size:15px; padding:10px 10px 10px 5px; width:100%;"
                  (click)="navigateToNotification(value)">
                  <lucide-icon name="dot" style="margin-right:2px;" size="24"></lucide-icon>
                  @if (value.referenceObject) {
                    {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate: {task: '"'+value.referenceObject.name+'"'} }}
                  }
                  @if (!value.referenceObject) {
                    {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate}}
                  }
                </button>
                <hr style="margin:0;" />
              </div>
            }
            <button ngbDropdownItem style="text-align:center; color:var(--navy-600);" (click)="navigateToNotifications()">
              {{'NOTIFICATIONS.SEE_ALL' | translate}}
            </button>
          </div>
        </div>
        <!-- Mobile toggler -->
        <button class="navbar-toggler mobile-toggler-btn" type="button"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-label="Toggle navigation">
          <lucide-icon [name]="mobileMenuOpen ? 'x-lg' : 'list'" style="color:white; display:block;" size="21"></lucide-icon>
        </button>
        <!-- Nav + controls -->
        <div class="collapse navbar-collapse" id="mainNav">
          <!-- Left nav links -->
          <ul class="navbar-nav align-items-center me-auto">
            <li class="nav-item">
              <div ngbDropdown class="d-inline-block">
                <button class="btn btn-link nav-item-btn" [class.nav-item-active]="isServicesRoute" ngbDropdownToggle>
                  <lucide-icon name="list" style="margin-right:4px;" size="16"></lucide-icon>
                  {{'HEADER.SERVICES' | translate}}
                </button>
                <div ngbDropdownMenu>
                  @for (value of services; track value) {
                    <button ngbDropdownItem routerLink="/csv-list/{{value.id}}">
                      {{value.name}}
                    </button>
                  }
                </div>
              </div>
            </li>
            @if (auth.isloggedIn) {
              <li class="nav-item">
                <a class="nav-link nav-item-btn" routerLink="/company" routerLinkActive="nav-item-active">
                  <lucide-icon name="building-2" style="margin-right:4px;" size="16"></lucide-icon>
                  {{'HEADER.PROFILES' | translate}}
                </a>
              </li>
            }
            <li class="nav-item">
              <a class="nav-link nav-item-btn" routerLink="/home" routerLinkActive="nav-item-active">
                <lucide-icon name="chart-pie" style="margin-right:4px;" size="16"></lucide-icon>
                {{'HEADER.DASHBOARDS' | translate}}
              </a>
            </li>
            @if (auth.isloggedIn) {
              <li class="nav-item">
                <a class="nav-link nav-item-btn" routerLink="/indicator" routerLinkActive="nav-item-active">
                  <lucide-icon name="layout-grid" style="margin-right:4px;" size="16"></lucide-icon>
                  {{'HEADER.INDICATORS' | translate}}
                </a>
              </li>
            }
            @if (auth.isloggedIn) {
              <li class="nav-item">
                <a class="nav-link nav-item-btn" routerLink="/report" routerLinkActive="nav-item-active">
                  <lucide-icon name="trending-up" style="margin-right:4px;" size="16"></lucide-icon>
                  {{'HEADER.REPORTS' | translate}}
                </a>
              </li>
            }
            @if (auth.isloggedIn) {
              <li class="nav-item">
                <a class="nav-link nav-item-btn" routerLink="/help" routerLinkActive="nav-item-active">
                  <lucide-icon name="circle-question-mark" style="margin-right:4px;" size="16"></lucide-icon>
                  {{'HEADER.HELP' | translate}}
                </a>
              </li>
            }
            @if (auth.isloggedIn && user?.roles.includes('ADMIN')) {
              <li class="nav-item">
                <div ngbDropdown class="d-inline-block" placement="bottom-start">
                  <button class="btn btn-link nav-item-btn" [class.nav-item-active]="isAdminRoute" ngbDropdownToggle>
                    <lucide-icon name="settings" style="margin-right:4px;" size="16"></lucide-icon>
                    {{'HEADER.ADMIN' | translate}}
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem routerLink="/ext-api">{{'HEADER.EXTERNAL_API_MANAGER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/service">{{'HEADER.SERVICE_MANAGER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/user">{{'HEADER.USER_MANAGER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/batch-process">{{'HEADER.BATCH_PROCESS_MANAGER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/dashboard">{{'HEADER.DASHBOARD_CONFIGURATION' | translate}}</button>
                    <button ngbDropdownItem routerLink="/portal-dashboard-group">{{'PORTAL.GROUP_TITLE' | translate}}</button>
                    <button ngbDropdownItem routerLink="/portal-content">{{'ADMIN.PORTAL_CONTENT' | translate}}</button>
                    <button ngbDropdownItem routerLink="/portal-newsletter">{{'ADMIN.PORTAL_NEWSLETTER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/currency">{{'HEADER.CURRENCY_MANAGER' | translate}}</button>
                    <button ngbDropdownItem routerLink="/currency-rates">{{'HEADER.CURRENCY_RATES' | translate}}</button>
                    <button ngbDropdownItem routerLink="/payee-sector">{{'HEADER.PAYEE_SECTORS' | translate}}</button>
                    <button ngbDropdownItem routerLink="/regional-officer">{{'HEADER.REGIONAL_OFFICER_SETUP' | translate}}</button>
                    <button ngbDropdownItem routerLink="/indicator-sectors">{{'HEADER.INDICATOR_SECTORS' | translate}}</button>
                    <button ngbDropdownItem routerLink="/control-team">{{'HEADER.CONTROL_TEAMS' | translate}}</button>
                    <!--                                <button ngbDropdownItem routerLink="/admin">{{'HEADER.ADMIN' | translate}}</button>-->
                    <button ngbDropdownItem routerLink="/help-editor">{{'HEADER.HELP_EDITOR' | translate}}</button>
                  </div>
                </div>
              </li>
            }
            @if (controlsModuleEnabled && (auth.isloggedIn && (this.user?.roles.includes('ADMIN') || this.user?.roles.includes('DIRECTOR_GENERAL')
              || this.user?.roles.includes('DIRECTOR_APPROVER') || this.user?.roles.includes('CONTROLLER')
              || this.user?.roles.includes('COORDINATOR') || this.user?.roles.includes('CHEF')
              || this.user?.roles.includes('INSPECTOR')) || isAssigned)) {
              <li class="nav-item"
                >
                <a class="nav-link nav-item-btn" (click)="openControlModule()">
                  <lucide-icon name="cpu" style="margin-right:4px;" size="19"></lucide-icon>
                  {{'HEADER.CONTROL_MODULE' | translate}}
                </a>
              </li>
            }
          </ul>
          <!-- Right controls -->
          <div class="d-flex align-items-center flex-shrink-0">
            @for (code of languages; track code) {
              <img [src]="flagFor(code)" (click)="setLang(code)" [alt]="code"
                class="lang-flag" [class.lang-flag-fr]="code === 'fr'"
                [ngClass]="lang === code ? '' : 'unselected_lang'">
            }
            <div ngbDropdown placement="bottom-end">
              <button class="btn btn-link header-icon-btn" ngbDropdownToggle>
                <lucide-icon name="bell" size="24"></lucide-icon>
                @if (unseenNotifications > 0) {
                  <span class="notification_num">{{this.unseenNotifications}}</span>
                }
              </button>
              <div ngbDropdownMenu class="dropdown-menu-end">
                @for (value of dropDownNotifications?.slice(0,10); track value) {
                  <div style="width:100%;">
                    <button ngbDropdownItem style="font-size:15px; padding:10px 10px 10px 5px; width:100%;"
                      (click)="navigateToNotification(value)">
                      <lucide-icon name="dot" style="margin-right:2px;" size="24"></lucide-icon>
                      @if (value.referenceObject) {
                        {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate: {task: '"'+value.referenceObject.name+'"'} }}
                      }
                      @if (!value.referenceObject) {
                        {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate}}
                      }
                    </button>
                    <hr style="margin:0;" />
                  </div>
                }
                <button ngbDropdownItem style="text-align:center; color:var(--navy-600);" (click)="navigateToNotifications()">
                  {{'NOTIFICATIONS.SEE_ALL' | translate}}
                </button>
              </div>
            </div>
            <div ngbDropdown placement="bottom-end">
              <button class="btn btn-link header-icon-btn user-avatar-btn" ngbDropdownToggle>
                <app-user-avatar [user]="user"></app-user-avatar>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-end">
                <button type="button" ngbDropdownItem (click)="userAccount()">
                  <lucide-icon name="user" style="margin-right:4px;" size="18"></lucide-icon>
                  {{this.user?.username}}
                </button>
                <button type="button" ngbDropdownItem (click)="releaseNotes()">
                  <lucide-icon name="notebook-text" style="margin-right:4px;" size="18"></lucide-icon>
                  {{'RELEASE.MENU' | translate}}
                </button>
                <button type="button" ngbDropdownItem (click)="reportIssue()">
                  <lucide-icon name="bug" style="margin-right:4px;" size="18"></lucide-icon>
                  {{'ISSUE.REPORT_MENU' | translate}}
                </button>
                <button type="button" ngbDropdownItem (click)="logout()">
                  <lucide-icon name="log-out" style="margin-right:4px;" size="18"></lucide-icon>
                  {{'HEADER.LOGOUT' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  }

  <!-- ── Mobile sidenav floating tab (left-edge, below xl breakpoint only) ── -->
  @if (auth.isloggedIn && leftMenuItems?.length > 0 && !sidenavOpen) {
    <button class="sidenav-float-tab d-xl-none"
      (click)="toggleSidenav()"
      [attr.aria-expanded]="sidenavOpen"
      aria-label="Toggle section menu">
      <lucide-icon name="panel-left" style="color:var(--fg-on-navy); display:block;" size="21"></lucide-icon>
    </button>
  }

  <!-- ── Mobile nav: backdrop + slide-in drawer (below xl breakpoint only) ── -->

  <!-- Backdrop: tap to close -->
  @if (mobileMenuOpen) {
    <div class="mobile-nav-overlay d-xl-none"
      (click)="closeMobileMenu()">
    </div>
  }

  <!-- Drawer panel -->
  @if (mobileMenuOpen) {
    <div class="mobile-nav-drawer d-xl-none">
      <!-- Drawer header: logo + close button -->
      <div class="mobile-nav-drawer-header">
        <a routerLink="/" (click)="closeMobileMenu()" class="mobile-drawer-brand">
          <img src="assets/img/logo-header.png"
            style="height: 36px; display:inline-block; vertical-align:middle;">
          <span class="brand-title" style="font-size:1.05em; margin-left:10px; color:var(--fg-on-navy);">
            {{'HEADER.INFO' | translate}}
          </span>
        </a>
        <button class="mobile-drawer-close" (click)="closeMobileMenu()"
          aria-label="Close navigation">
          <lucide-icon name="x" style="color:rgba(255,255,255,0.8); display:block;" size="21"></lucide-icon>
        </button>
      </div>
      <!-- Drawer body: all nav items (unchanged content) -->
      <div class="mobile-nav-body">
        <!-- Services accordion -->
        <div class="mobile-nav-item">
          <button class="mobile-nav-link" [class.mobile-nav-active]="isServicesRoute" (click)="servicesExpanded = !servicesExpanded">
            <lucide-icon name="list" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{'HEADER.SERVICES' | translate}}</span>
            <lucide-icon [name]="servicesExpanded ? 'chevron-up' : 'chevron-down'" class="mobile-chevron" size="16"></lucide-icon>
          </button>
          @if (servicesExpanded) {
            <div class="mobile-nav-submenu">
              @for (value of services; track value) {
                <button class="mobile-nav-sublink"
                  [routerLink]="['/csv-list', value.id]" (click)="closeMobileMenu()">
                  {{value.name}}
                </button>
              }
            </div>
          }
        </div>
        @if (auth.isloggedIn) {
          <a class="mobile-nav-link" routerLink="/company" routerLinkActive="mobile-nav-active"
            (click)="closeMobileMenu()">
            <lucide-icon name="building-2" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{'HEADER.PROFILES' | translate}}</span>
          </a>
        }
        <a class="mobile-nav-link" routerLink="/home" routerLinkActive="mobile-nav-active"
          (click)="closeMobileMenu()">
          <lucide-icon name="chart-pie" class="mobile-nav-icon" size="16"></lucide-icon>
          <span>{{'HEADER.DASHBOARDS' | translate}}</span>
        </a>
        @if (auth.isloggedIn) {
          <a class="mobile-nav-link" routerLink="/indicator" routerLinkActive="mobile-nav-active"
            (click)="closeMobileMenu()">
            <lucide-icon name="layout-grid" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{'HEADER.INDICATORS' | translate}}</span>
          </a>
        }
        @if (auth.isloggedIn) {
          <a class="mobile-nav-link" routerLink="/report" routerLinkActive="mobile-nav-active"
            (click)="closeMobileMenu()">
            <lucide-icon name="trending-up" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{'HEADER.REPORTS' | translate}}</span>
          </a>
        }
        @if (auth.isloggedIn) {
          <a class="mobile-nav-link" routerLink="/help" routerLinkActive="mobile-nav-active"
            (click)="closeMobileMenu()">
            <lucide-icon name="circle-question-mark" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{'HEADER.HELP' | translate}}</span>
          </a>
        }
        <!-- Admin accordion -->
        @if (auth.isloggedIn && user?.roles.includes('ADMIN')) {
          <div class="mobile-nav-item">
            <button class="mobile-nav-link" [class.mobile-nav-active]="isAdminRoute" (click)="adminExpanded = !adminExpanded">
              <lucide-icon name="settings" class="mobile-nav-icon" size="16"></lucide-icon>
              <span>{{'HEADER.ADMIN' | translate}}</span>
              <lucide-icon [name]="adminExpanded ? 'chevron-up' : 'chevron-down'" class="mobile-chevron" size="16"></lucide-icon>
            </button>
            @if (adminExpanded) {
              <div class="mobile-nav-submenu">
                <button class="mobile-nav-sublink" routerLink="/ext-api" (click)="closeMobileMenu()">{{'HEADER.EXTERNAL_API_MANAGER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/service" (click)="closeMobileMenu()">{{'HEADER.SERVICE_MANAGER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/user" (click)="closeMobileMenu()">{{'HEADER.USER_MANAGER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/batch-process" (click)="closeMobileMenu()">{{'HEADER.BATCH_PROCESS_MANAGER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/dashboard" (click)="closeMobileMenu()">{{'HEADER.DASHBOARD_CONFIGURATION' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/portal-dashboard-group" (click)="closeMobileMenu()">{{'PORTAL.GROUP_TITLE' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/portal-content" (click)="closeMobileMenu()">{{'ADMIN.PORTAL_CONTENT' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/portal-newsletter" (click)="closeMobileMenu()">{{'ADMIN.PORTAL_NEWSLETTER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/currency" (click)="closeMobileMenu()">{{'HEADER.CURRENCY_MANAGER' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/currency-rates" (click)="closeMobileMenu()">{{'HEADER.CURRENCY_RATES' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/payee-sector" (click)="closeMobileMenu()">{{'HEADER.PAYEE_SECTORS' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/regional-officer" (click)="closeMobileMenu()">{{'HEADER.REGIONAL_OFFICER_SETUP' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/indicator-sectors" (click)="closeMobileMenu()">{{'HEADER.INDICATOR_SECTORS' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/control-team" (click)="closeMobileMenu()">{{'HEADER.CONTROL_TEAMS' | translate}}</button>
                <button class="mobile-nav-sublink" routerLink="/help-editor" (click)="closeMobileMenu()">{{'HEADER.HELP_EDITOR' | translate}}</button>
              </div>
            }
          </div>
        }
        <!-- Control module -->
        @if (controlsModuleEnabled && (auth.isloggedIn && (user?.roles.includes('ADMIN') || user?.roles.includes('DIRECTOR_GENERAL')
          || user?.roles.includes('DIRECTOR_APPROVER') || user?.roles.includes('CONTROLLER')
          || user?.roles.includes('COORDINATOR') || user?.roles.includes('CHEF')
          || user?.roles.includes('INSPECTOR')) || isAssigned)) {
          <a class="mobile-nav-link"
            (click)="openControlModule(); closeMobileMenu()">
            <lucide-icon name="cpu" class="mobile-nav-icon" size="18"></lucide-icon>
            <span>{{'HEADER.CONTROL_MODULE' | translate}}</span>
          </a>
        }
      </div>
      <!-- Footer row: language + user actions -->
      <div class="mobile-nav-footer">
        <div class="mobile-lang-group">
          @for (code of languages; track code) {
            <img [src]="flagFor(code)" (click)="setLang(code)" [alt]="code"
              class="lang-flag" [class.lang-flag-fr]="code === 'fr'"
              [ngClass]="lang === code ? '' : 'unselected_lang'">
          }
        </div>
        <button class="mobile-footer-btn" (click)="userAccount(); closeMobileMenu()">
          <app-user-avatar [user]="user"></app-user-avatar>
          <span class="mobile-footer-label">{{user?.username}}</span>
        </button>
        <button class="mobile-footer-btn" (click)="releaseNotes(); closeMobileMenu()">
          <lucide-icon name="notebook-text" size="19"></lucide-icon>
          <span class="mobile-footer-label">{{'RELEASE.MENU' | translate}}</span>
        </button>
        <button class="mobile-footer-btn" (click)="reportIssue(); closeMobileMenu()">
          <lucide-icon name="bug" size="19"></lucide-icon>
          <span class="mobile-footer-label">{{'ISSUE.REPORT_MENU' | translate}}</span>
        </button>
        <button class="mobile-footer-btn mobile-logout-btn" (click)="logout(); closeMobileMenu()">
          <lucide-icon name="log-out" size="19"></lucide-icon>
          <span class="mobile-footer-label">{{'HEADER.LOGOUT' | translate}}</span>
        </button>
      </div>
    </div>
  }

  <!-- ── Mobile sidenav: backdrop + slide-in drawer ── -->

  <!-- Sidenav backdrop: tap to close -->
  @if (sidenavOpen) {
    <div class="mobile-sidenav-backdrop d-xl-none"
      (click)="closeSidenav()">
    </div>
  }

  <!-- Sidenav drawer -->
  @if (auth.isloggedIn && sidenavOpen) {
    <div class="mobile-sidenav-drawer d-xl-none"
      >
      <div class="mobile-sidenav-header">
        <span class="mobile-sidenav-title">{{'HEADER.MENU' | translate}}</span>
        <button class="mobile-drawer-close" (click)="closeSidenav()" aria-label="Close section menu">
          <lucide-icon name="x" style="color:rgba(255,255,255,0.8); display:block;" size="21"></lucide-icon>
        </button>
      </div>
      <div class="mobile-sidenav-body">
        @for (menuItem of leftMenuItems; track menuItem) {
          <a
            [routerLink]="menuItem.link"
            [fragment]="menuItem.fragment"
            [class.active-links]="isMenuItemActive(menuItem)"
            (click)="closeSidenav()">
            {{ menuItem.title | translate }}
          </a>
        }
      </div>
    </div>
  }

  @if (auth.isloggedIn && leftMenuItems?.length) {
    <div class="sidenav d-none d-xl-block">
      <!--
        [fragment] is undefined for every ordinary menu item and is the card id
        on the help page, whose menu is the page's own contents.
      -->
      @for (menuItem of leftMenuItems; track menuItem) {
        <a [routerLink]="menuItem.link" [fragment]="menuItem.fragment"
           [class.active-links]="isMenuItemActive(menuItem)">
          {{ menuItem.title | translate}}
        </a>
      }
    </div>
  }

</div>
